import { Box, Stack } from "@mui/material";
import React from "react";

import KeyVal from "./KeyVal";

const NiceArrayCell = (props) => {
  const cellObject = props.children;

  if (Array.isArray(cellObject)) {
    // Check if all items are primitives
    const allPrimitive = cellObject.every(
      (item) => typeof item !== "object" || item === null
    );

    if (allPrimitive) {
      return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 0.5 }}>
          {cellObject.map((item, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: "#e8f0fe",
                color: "#1a73e8",
                borderRadius: "4px",
                px: 1,
                py: 0.25,
                fontSize: "0.8rem",
                lineHeight: 1.4,
                wordBreak: "break-word",
              }}
            >
              {String(item)}
            </Box>
          ))}
        </Box>
      );
    }

    return (
      <Box>
        {cellObject.map((item, index) => (
          <Stack key={index} direction={"row"} spacing={2}>
            {typeof item === "object" && item !== null && !Array.isArray(item) ? (
              Object.keys(item).map((fieldName) => (
                <KeyVal
                  key={fieldName}
                  label={fieldName}
                  value={item[fieldName]}
                  correctLabel={true}
                  labelBold={true}
                />
              ))
            ) : (
              <Box>{String(item)}</Box>
            )}
          </Stack>
        ))}
      </Box>
    );
  } else {
    return <Box>Not an Array</Box>;
  }
};


export default NiceArrayCell;
